import { FieldErrors, FieldPath, get } from 'react-hook-form';
import { OfferFormValues } from '../components/offer-form/offer-form.schema';
import { OfferFormPanel } from '../constants/offer-form-panel.enum';

/** Everything open except the product details – those are only changed for different conditions. */
export const INITIALLY_OPEN_PANELS: OfferFormPanel[] = [
  OfferFormPanel.PRODUCT,
  OfferFormPanel.ADD_ONS,
  OfferFormPanel.CUSTOMER,
  OfferFormPanel.PAYMENT,
  OfferFormPanel.OFFER_FILE
];

const CUSTOMER_FIELDS = [
  'mail',
  'firstName',
  'lastName',
  'name',
  'vatId',
  'street',
  'houseNumber',
  'postCode',
  'city',
  'country',
  'invoiceMail',
  'phone'
] as const;

const PANEL_FIELDS: Record<OfferFormPanel, FieldPath<OfferFormValues>[]> = {
  [OfferFormPanel.PRODUCT]: ['term', 'productId'],
  [OfferFormPanel.PRODUCT_DETAILS]: ['title', 'description', 'monthlyPrice', 'additionalConditions'],
  [OfferFormPanel.ADD_ONS]: ['addOnIds'],
  [OfferFormPanel.CUSTOMER]: CUSTOMER_FIELDS.map((field) => `customer.${field}` as const),
  // IBAN and BIC only exist in the correction form.
  [OfferFormPanel.PAYMENT]: ['paymentMethod', 'customer.newCustomerDate', 'customer.iban', 'customer.bic'],
  // The PDF is no form field – it is checked by the upload field itself.
  [OfferFormPanel.OFFER_FILE]: []
};

/** The details sit inside the product panel, so both have to be open to show their errors. */
export const getPanelsToOpenForErrors = (errors: FieldErrors<OfferFormValues>): OfferFormPanel[] => {
  const panels = Object.values(OfferFormPanel).filter((panel) => PANEL_FIELDS[panel].some((field) => get(errors, field)));
  return panels.includes(OfferFormPanel.PRODUCT_DETAILS) ? [...panels, OfferFormPanel.PRODUCT] : panels;
};
